import * as React from 'react';
import ScreenReaderOnly from '../ScreenReaderOnly/ScreenReaderOnly';
var FocusTrap = function (_a) {
    var children = _a.children;
    //@ts-ignore
    var firstButton = React.useRef();
    //@ts-ignore
    var lastButton = React.useRef();
    var onFirstReached = function (e) {
        if (e.shiftKey && e.key === 'Tab') {
            e.preventDefault();
            lastButton.current.focus();
        }
    };
    var onLastReached = function (e) {
        if (!e.shiftKey && e.key === 'Tab') {
            e.preventDefault();
            firstButton.current.focus();
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(ScreenReaderOnly, null,
            React.createElement("button", { ref: firstButton, onKeyDown: onFirstReached })),
        children,
        React.createElement(ScreenReaderOnly, null,
            React.createElement("button", { ref: lastButton, onKeyDown: onLastReached }))));
};
export default FocusTrap;
//# sourceMappingURL=FocusTrap.js.map